import { defineComponent as _defineComponent } from 'vue'
import Navbar from "@/components/Navbar.vue";
import Loader from "@/components/common/Loader.vue";
import AddressExplorer from "@/components/common/AddressExplorer.vue";
import {
	useCacheStore,
	useSettingsStore,
	useSolanaStore,
	useSwapStore,
	useWalletStore,
} from "./pinia";
import store from "./store";
import { computed, watch } from "vue";
import { FLUXB_MINT, SOL_MINT } from "./shared";
import { useAlertStore } from "./pinia/alertStore";
import Toast from "./components/common/Toast.vue";
import TokenLoad from "./components/token/TokenLoad.vue";
import TransactionsHistory from "./components/transaction/TransactionsHistory.vue";
import SignatureStatusModal from "./components/transaction/SignatureStatusModal.vue";
import CandleInspector from "./components/trade/CandleInspector.vue";

// computed

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const isBot = computed<(path: string) => boolean>(() => (path: string) => {
	return path.indexOf("/bot") > -1;
});

// data
const cacheStore = useCacheStore();
const solanaStore = useSolanaStore();
const settingsStore = useSettingsStore();
const alertStore = useAlertStore();
const walletStore = useWalletStore();
const swapStore = useSwapStore();

// setup
store.commit(
	"solana/set_endpoint",
	store.state.settings.customRpcUrl || store.state.rpc.rpcUrl
);
store.dispatch("solana/fetchClusterFees");
cacheStore.fetchNameMap();

solanaStore.init(settingsStore.settings.customRpcUrl || store.state.rpc.rpcUrl);
solanaStore.fetchClusterFees();
cacheStore.fetchMintPriceUSD(SOL_MINT);
cacheStore.fetchMintPriceUSD(FLUXB_MINT);

// watch
watch(
	() => walletStore.isConnected,
	() => {
		swapStore.getTransactionsHistory(walletStore.address?.toString());
	}
);

return { __sfc: true,isBot, cacheStore, solanaStore, settingsStore, alertStore, walletStore, swapStore, Navbar, Loader, AddressExplorer, store, Toast, TransactionsHistory, SignatureStatusModal, CandleInspector }
}

})